import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login.service'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CookieStorageService } from '@sharedServices/cookie-storage.service';
import { NotificationService } from '@sharedServices/notification.service'
import { RedirectionLinksService } from '@sharedServices/redirection-links.service';
import {FormControl, Validators} from '@angular/forms';

@Component({
  selector: 'app-role-dialog',
  templateUrl: './role-dialog.component.html',
  styleUrls: ['./role-dialog.component.scss']
})

export class RoleDialogComponent implements OnInit {

  userRoles: string[] = []
  userRole: FormControl = new FormControl('', Validators.required)

  constructor(
    private router: Router,
    public roleDialogRef: MatDialogRef<RoleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public loginData: any,
    private loginService: LoginService,
    public cookieStorageService: CookieStorageService,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this.cookieStorageService.setCookie('webApp_accessToken', this.loginData.access_token, this.loginData.expires_in)
    this.loginService.getUserRoles().subscribe((response: any) => {
      response.data.role.forEach(role => {
        this.userRoles.push(role.authority)
      })
    })
  }

  setActiveRole(): void {
    this.loginService.setUserRole({roleName: this.userRole.value}).subscribe(() => {
      this.cookieStorageService.setCookie('webApp_activeRole', this.userRole.value, this.loginData.expires_in)

      let redirectionUrl = RedirectionLinksService.getRedirectionLink(this.userRole.value)
      if(redirectionUrl) {
        this.notificationService.showSuccess(`Successfully logged in as<br>${this.userRole.value}`)
        this.roleDialogRef.close()
        this.router.navigateByUrl('adminApp/' + redirectionUrl)
      } else {
        this.notificationService.showError('Inactive Role<br>Please contact ADMIN')
        this.cookieStorageService.clearAllCookies()
      }
    })
  }
}
